var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question_mark_tooltip_icon",
    "data-name": "question mark tooltip icon",
    transform: "translate(-819 -1130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_18",
    "data-name": "Path 18",
    transform: "translate(819 1130)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12 1.5 C 6.21027946472168 1.5 1.5 6.21027946472168 1.5 12 C 1.5 17.78972053527832 6.21027946472168 22.5 12 22.5 C 17.78972053527832 22.5 22.5 17.78972053527832 22.5 12 C 22.5 6.21027946472168 17.78972053527832 1.5 12 1.5 M 12 0 C 18.62742042541504 0 24 5.372579574584961 24 12 C 24 18.62742042541504 18.62742042541504 24 12 24 C 5.372579574584961 24 0 18.62742042541504 0 12 C 0 5.372579574584961 5.372579574584961 0 12 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(831 1148)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Nunito-Bold, Nunito",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.672,
    y: 0
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkTooltipIcon);
export default __webpack_public_path__ + "static/media/question-mark-tooltip-icon.10c4e69fda3a68beb4dcf86092e9a72e.svg";
export { ForwardRef as ReactComponent };